import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GalleryAccessLevel } from '../../../lib/access-level';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { AccessLevelPipe } from '../../pipes/access-level.pipe';

@Component({
  selector: 'app-gallery-share-context',
  templateUrl: './gallery-share-context.component.html',
  styleUrls: ['./gallery-share-context.component.scss'],
  standalone: true,
  imports: [
    SvgComponent,
    TooltipDirective,
    ContextMenuComponent,
    ButtonDirective,
    ButtonMenuItemComponent,
    AccessLevelPipe,
  ],
})
export class GalleryShareContextComponent {
  @Input() accessLevel: GalleryAccessLevel;
  @Input() accessLevels: (GalleryAccessLevel | 'remove' | 'leave')[];
  @Input() disabled: boolean;
  @Input() centerVertically = true;
  @Input() mode: 'link' | 'team' | 'member' | 'member-invite' | 'invite-field' | 'group';
  @Input() red: boolean;
  @Input() warningMessage?: string;
  @Output() onChange = new EventEmitter();
  alDescription = {
    review: 'Can view and give feedback.',
    view_only: 'Can only view assets.',
    edit: 'Can edit, upload and delete.',
    no_access: 'Only invited people can access.',
  };
}
